<script>
import BaseCard from "../Accommodatie/BaseCard";

export default {
  name: "MainPropertiesCard",
  extends: BaseCard,
  props: ["user"],
  data: function() {
    return {
      header: "Algemeen",
      disabled: true,
      values: {
        username: this.user.username,
        email: this.user.email
      }
    };
  },
  computed: {
    schema: function() {
      return [
        {
          type: "text",
          name: "username",
          label: "Gebruikersnaam",
          placeholder: "Gebruikersnaam",
          disabled: true,
          "input-class": this.disabled ? "disabled" : ""
        },
        {
          type: "email",
          name: "email",
          label: "E-mail",
          validation: "^required|email",
          "validation-messages": {
            required: "Email is verplicht",
            email: "Dit is geen valide e-mail"
          },
          placeholder: "E-mail",
          disabled: this.disabled,
          "input-class": this.disabled ? "disabled" : ""
        },

        {
          type: "submit",
          "input-class": ["btn", "btn-blue", this.disabled ? "disabled" : ""],
          label: "Opslaan"
        }
      ];
    }
  },
  methods: {
    submitHandler: function() {}
  }
};
</script>
